export default "__VITE_ASSET__e2e56efa__"